import { isPlainObject, isString } from 'lodash';

// The My logged care card remembers the mode (day / week / month / custom) and,
// for custom, the inclusive YYYY-MM-DD bounds, per user: someone tracking a pay
// period should not have to reselect it every visit (SYN-388). Keyed by user so
// a shared browser never shows one person's range to another.
const CARE_STATS_RANGE_KEY_PREFIX = 'synergrx.careStatsRange';

function careStatsRangeKey(userId) {
    return `${CARE_STATS_RANGE_KEY_PREFIX}.${userId}`;
}

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const isIsoDate = (value) => isString(value) && ISO_DATE_PATTERN.test(value);

// {mode, startDate, endDate} or null when nothing valid is stored
export function getCareStatsRange(userId) {
    if (!userId) {
        return null;
    }
    try {
        const stored = window.localStorage.getItem(careStatsRangeKey(userId));
        if (!stored) {
            return null;
        }
        const parsed = JSON.parse(stored);
        if (!isPlainObject(parsed) || !isString(parsed.mode)) {
            return null;
        }
        return {
            mode: parsed.mode,
            startDate: isIsoDate(parsed.startDate) ? parsed.startDate : null,
            endDate: isIsoDate(parsed.endDate) ? parsed.endDate : null
        };
    } catch (e) {
        // ignore — storage disabled / privacy mode / corrupt value
        return null;
    }
}

export function setCareStatsRange(userId, { mode, startDate, endDate }) {
    if (!userId || !mode) {
        return;
    }
    try {
        window.localStorage.setItem(careStatsRangeKey(userId), JSON.stringify({ mode, startDate, endDate }));
    } catch (e) {
        // ignore — quota / privacy mode
    }
}
